import React from "react";
import { useTranslation } from "react-i18next";
import DynamicProductComparison from "./ProductComparison";
import { trackerData } from "./deta-ProductComparison/trackerData";
import { trackerTranslations } from "./deta-ProductComparison/trackerTranslations";

const TrackerComparison: React.FC = () => {
    const { i18n } = useTranslation();
    const lang = (i18n.language || "fa").split("-")[0];
    const langKey = (["fa", "en", "ar", "tr"].includes(lang) ? lang : "fa") as keyof typeof trackerTranslations;
    const t = trackerTranslations[langKey] || trackerTranslations.fa;

    return (
        <DynamicProductComparison
            title={t.title}
            subtitle={t.subtitle}
            description={t.description}
            data={trackerData}
            defaultCategory="all"
            showCategories={false}
        />
    );
};

export default TrackerComparison;